import * as React from 'react'
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar'
import MuiAlert, { AlertProps } from '@mui/material/Alert'

export interface State extends SnackbarOrigin {
  open: boolean
}

interface Message {
  message: string
  severity: any
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const SnackBarAlert: React.FC<Message> = ({ severity = 'success', message }): JSX.Element => {
  const [state, setState] = React.useState<State>({
    open: true,
    vertical: 'top',
    horizontal: 'right',
  })
  const { vertical, horizontal, open } = state

  const handleClose = () => {
    setState({ ...state, open: false })
  }

  return (
    <div>
      <Snackbar open={open} anchorOrigin={{ vertical, horizontal }} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%', backgroundColor: '#0A688D' }}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default SnackBarAlert
